import styled from "styled-components";

export const Logo = styled.span`
  span:first-child {
    color: #00758f;
  }

  span:last-child {
    color: #f29110;
  }

  cursor: pointer;
  font-size: 30px;
  font-weight: bolder;
  font-family: 'Titillium Web', Roboto, 'Helvetica Neue', 'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
`
